import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from 'redux';
import ActionTypes from "../../../../constants/ActionTypes";
import MiddlewareEntities from "../../../../constants/MiddlewareEntities";
import CampaignEanexSubmitObjectFactory from "../../../../factories/campaigns/CampaignEanexSubmitObjectFactory";
import { getCampaignChannelByChnlId } from "../../../../utilites/util";
import Validator from "../../../../validators/Validator";
import { setLoader } from "../../ui/actions";
import { getSessionData } from "../../sessionData/actions";
import { createErrorNotification, getNotification } from "../../notification/actions";
import { apiRequest } from '../../api/actions';
import { ISoftOfferPackage } from "../../../../entities/campaigns/types";
import SoftOfferPackageFactory from "../../../../factories/campaigns/SoftOfferPackageFactory";
import ApiUrls from "../../../../constants/ApiUrls";
import { HttpConstants } from "../../../../constants/HttpConstants";
import {
  setCampaignDetailsAction, setDetailsChannelNameAction, setDetailsIsUpSellAction, setDetailsOfferIdAction, setDetailsOptionIdAction,
  setDetailsOptionNameAction,
  setDetailsSoftOfferPackageAction,
  setDetailsTermsAction, setSubmitEanexMessage
} from "./actions";

export const getCampaignDetailsMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);
  switch (action.type) {
  case ActionTypes.CAMPAIGN.DETAILS.FETCH:
    const param = !Validator.isUndefined(action.params.eanex) ? `/${  action.params.eanex}` : '';
    next(apiRequest(
      null,
      HttpConstants.methods.GET,
      `${ApiUrls.CAMPAIGNS}/sms-electro-details/${action.params.code}${param}`,
      null,
      null,
      MiddlewareEntities.CAMPAIGN.DETAILS,
      {}),
    );
    next(setLoader(true, MiddlewareEntities.CAMPAIGN.DETAILS));
    break;
  case `${MiddlewareEntities.CAMPAIGN.DETAILS} ${ActionTypes.API_SUCCESS}` :
    next(setCampaignDetailsAction(action.payload.data));
    next(getSessionData(action.payload.data.session));
    next(getNotification(action.payload.data.session.flashMessages,  MiddlewareEntities.CAMPAIGN.DETAILS));
    next(setLoader(false, MiddlewareEntities.CAMPAIGN.DETAILS));
    break;
  case `${MiddlewareEntities.CAMPAIGN.DETAILS} ${ActionTypes.API_ERROR}` :
    next(setLoader(false, MiddlewareEntities.CAMPAIGN.DETAILS));
    next(createErrorNotification(action.payload.data,  MiddlewareEntities.CAMPAIGN.DETAILS));
    break;
  }
};

export const submitEanexMiddleware: Middleware = (store:MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);

  switch (action.type) {
  case ActionTypes.CAMPAIGN.DETAILS.SUBMIT_EANEX:
    // agreed with back team that this is only way to know url to watch for number 1 in url
    let url = window.location.pathname;
    if (url.endsWith('/')) {
      url = url.slice(0, url.length - 1);
    }
    const submitUrl = url.endsWith('/1') ? "accept-eanex" : "submit";
    const submitDataObject = CampaignEanexSubmitObjectFactory.create(store.getState().campaign.details, action.payload);
    next(apiRequest(
      null,
      HttpConstants.methods.POST,
      `${ApiUrls.CAMPAIGNS}/${submitUrl}`,
      null,
      submitDataObject,
      MiddlewareEntities.CAMPAIGN.SUBMIT_EANEX,
      {}),
    );
    next(setLoader(true, MiddlewareEntities.CAMPAIGN.SUBMIT_EANEX));
    break;
  case `${MiddlewareEntities.CAMPAIGN.SUBMIT_EANEX} ${ActionTypes.API_SUCCESS}` :
    next(setSubmitEanexMessage('Uspešno ste poslali zahtev za obnovu ugovora'));
    next(getSessionData(action.payload.data.session));
    next(getNotification(action.payload.data.session.flashMessages,  MiddlewareEntities.CAMPAIGN.SUBMIT_EANEX));
    next(setLoader(false, MiddlewareEntities.CAMPAIGN.SUBMIT_EANEX));
    break;
  case `${MiddlewareEntities.CAMPAIGN.SUBMIT_EANEX} ${ActionTypes.API_ERROR}` :
    next(setLoader(false, MiddlewareEntities.CAMPAIGN.DETAILS));
    next(createErrorNotification(action.payload.data,  MiddlewareEntities.CAMPAIGN.SUBMIT_EANEX));
    break;
  }
};

export const createCampaignDetailsMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);

  if (action.type.includes(ActionTypes.CAMPAIGN.DETAILS.CREATE)) {
    const tpOffer: ISoftOfferPackage = SoftOfferPackageFactory.create(action.payload.campaignData.tp);
    next(setDetailsSoftOfferPackageAction(tpOffer));
    next(setDetailsOptionNameAction(action.payload.campaignData.optionName));
    next(setDetailsTermsAction(action.payload.terms));
    next(setDetailsIsUpSellAction(action.payload.campaignData.upsell));
    next(setDetailsOfferIdAction(action.payload.campaignData.offerId));
    next(setDetailsOptionIdAction(action.payload.campaignData.optionId));
    next(setDetailsChannelNameAction(getCampaignChannelByChnlId(action.payload.campaignData.cnlId)));
  }
};

export const campaignDetailsMiddleware = [
  getCampaignDetailsMiddleware,
  createCampaignDetailsMiddleware,
  submitEanexMiddleware
];
